import courseService from "./CourseService";
import { useI18n } from "src/utils/lni18n";
import { useInput } from "src/components/Modalservice/UseInput";
import { useAlert } from "src/components/Modalservice/UseAlert";
import { isValidName, nameTooShortText } from "src/utils/NameRules";


export const useAddTheme = () => {

    const { languageService: t } = useI18n();
    const input = useInput();
    const alert = useAlert();

    async function addTheme(courseId: string) {

        try {
            const name = await input(t.getText("add.theme"), <div>{t.getText("name")}</div>);
            const trimmedName = (name || "").trim();
            // Only a cancel skips the check (it rejects, see catch); an entry of blanks gets told too.
            if (!isValidName(trimmedName)) {
                await alert("md", t.getText("add.theme"), nameTooShortText(t));
                return false;
            }
            await courseService.addTheme(courseId, trimmedName);
            return true;
        } catch (e) {
            console.error("Failed to add theme:", e);
            return false;
        }


    }
    return addTheme;

}